import script from "./HowWeWork.vue?vue&type=script&setup=true&lang=js"
export * from "./HowWeWork.vue?vue&type=script&setup=true&lang=js"

import "./HowWeWork.vue?vue&type=style&index=0&id=1fdf231a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fdf231a"]])

export default __exports__